export default __webpack_public_path__ + "static/media/correct-6033.ed3894f8.mp3";